import { observer } from 'mobx-react-lite'
import React from 'react'
import {
  EAccountStatus,
  getAccountStatus,
  IAccount,
} from 'shopify-payment-core'

import { useRoot } from '../atoms/RootProvider'
import { AccountBrickLayout } from '../molecules/AccountBrickLayout'
import { AccountIsBlocked } from '../molecules/AccountIsBlocked'
import { AccountWizard } from './AccountWizard'

interface IProps {
  account: IAccount
}

export const AccountControl = observer<IProps>(({ account }) => {
  const { auth } = useRoot()
  const status = getAccountStatus(account)

  if (!auth.isAdmin) {
    if (status === EAccountStatus.NEW || !account.billingPlan) {
      return <AccountWizard account={account} />
    }

    if (status === EAccountStatus.BLOCKED) {
      return <AccountIsBlocked reason={account.blockedReason} />
    }
  }

  return <AccountBrickLayout account={account} />
})
